import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from 'lib/api/apiClient';
import { CATALOG_URLS } from 'lib/api/endpoints';

export const fetchOrders = createAsyncThunk(
  'orders/fetchOrders',
  async (_, thunkAPI) => {
    try {
      const response = await apiClient.get(CATALOG_URLS.getAllOrders);
      return response.data?.data ?? response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.detail || 'Failed to fetch orders');
    }
  }
);

export const fetchAllOrders = createAsyncThunk(
  'orders/fetchAllOrders',
  async (_, thunkAPI) => {
    try {
      const response = await apiClient.get(CATALOG_URLS.getAllOrders);
      return response.data?.data ?? response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.detail || 'Failed to fetch all orders'
      );
    }
  }
);

export const updateOrderStatus = createAsyncThunk(
  'orders/updateOrderStatus',
  async ({ orderId, status }, thunkAPI) => {
    try {
      await apiClient.put(CATALOG_URLS.updateOrder(orderId), { status });
      return { orderId, status };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.detail || 'Failed to update order status'
      );
    }
  }
);

const orderSlice = createSlice({
  name: 'orders',
  initialState: {
    orders: [],
    allOrders: [],
    loading: false,
    error: null,
    tabValue: 1,
    searchTerm: '',
  },
  reducers: {
    setTabValue(state, action) {
      state.tabValue = action.payload;
    },
    setSearchTerm(state, action) {
      state.searchTerm = action.payload;
    },
    clearOrderError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAllOrders.fulfilled, (state, action) => {
        state.allOrders = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        const { orderId, status } = action.payload;
        const order = state.orders.find((o) => o.id === orderId);
        if (order) order.status = status;
        const adminOrder = state.allOrders.find((o) => o.id === orderId);
        if (adminOrder) adminOrder.status = status;
      })
      .addCase(updateOrderStatus.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setTabValue, setSearchTerm, clearOrderError } = orderSlice.actions;
export default orderSlice.reducer;
